import { render, staticRenderFns } from "./smtp.vue?vue&type=template&id=ba76805a&scoped=true"
import script from "./smtp.vue?vue&type=script&lang=js"
export * from "./smtp.vue?vue&type=script&lang=js"
import style0 from "./smtp.vue?vue&type=style&index=0&id=ba76805a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba76805a",
  null
  
)

export default component.exports